import { useEffect, useState } from "react";
import MainLayout from "../../components/layouts/MainLayout"
import { categoryApi } from "../../api/categoryApi";
import Swal from "sweetalert2";
import { message } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { Auth } from "../../utils/Auth";

const UpdateCategoryView = () =>{
    const {id} = useParams()
    const navigate = useNavigate()
    const [formData, setFormData] = useState({
            libelle: '',
            description: '',            
        })
    const [loading, setLoading] = useState(false);
    const abortController = new AbortController()

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
          // console.log(formData)

          const payload = {
            libelle:formData.libelle,
            description: formData.description,            
          }

          const res = await categoryApi.updateCategory(id,JSON.stringify(payload),abortController.signal)

          // console.log(res)

          if (!res.success) {
            return Swal.fire({
              title:'Impossible d\'enregistrer',
              text:res.message,
              // timer:3000
            })
          }

          message.success('Categorie modifiée avec succès');
          navigate(`/annonces/categories`)
        } catch (error) {
          message.error('Une erreur est survenue lors de la modification de la categorie');
          const messages = await error.messages ?? error.message;

          if(messages instanceof Array)
              return Swal.fire({
                title:messages.join('\n')!== 'Unauthenticated' ? "Erreur détectée" : "Session expirée",
                text:messages.join('\n')!== 'Unauthenticated' ? "Veuillez vous reconncter."  :  "Votre session a expirée veuillez vous reconnecter",
                icon:"error",
              }).then((result) => {
                Auth.removeSessionToken()
                return navigate(`/login`)			
              });
        } finally {
          setLoading(false);
        }
    }

    const handlefetchdata = async () => {
            setLoading(true)
    
            try {
                const res = await categoryApi.getCategory(id,abortController.signal)
    
                console.log(res)
     
                if(!res){
                    setLoading(false)
                    return message.error('Impossible de recuperer les donnees');
                }            
                setFormData({
                    ...res.data.category
                  });
                setLoading(false)
                console.log(formData)
     
             } catch (error) {
                 console.log(error)
                 message.error("Une erreur est survenue lors de la récupération des données")
                setLoading(false)
     
             }
        }

    useEffect(()=> {
            handlefetchdata()
          },[id])

    return <MainLayout>
        <div className="max-w-lg mx-auto p-6 bg-white rounded-lg shadow-md">
            <h2 className="text-2xl font-bold mb-4">Ajouter une categorie</h2>

            <form onSubmit={handleSubmit}>
                {/* Informations Utilisateur */}
                <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">Nom de la categorie <span className="text-red-600 text-sm italic">(Obligatoire)</span> </label>
                <input
                    type="text"
                    name="libelle"
                    value={formData.libelle}
                    onChange={handleChange}
                    required
                    className="w-full px-4 py-2 border border-gray-300 rounded-md"
                />
                </div>
        
        

                {/* Description/presentation */}
                <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">Description <span className="text-red-600 text-sm italic">(Optionnelcd)</span></label>         

                <textarea 
                    name="description"
                    value={formData.description}
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md"
                ></textarea>
                </div>

                {/* Soumission */}
                <div className="mt-6">
                <button
                    type="submit"
                    className="w-full px-4 py-2 bg-africasa-secondary text-white rounded-md hover:bg-africasa-primary"
                    disabled={loading}
                >
                    {loading ? 'Enregistrement...' : 'Ajouter'}
                </button>
                </div>
            </form>
        </div>
    </MainLayout>
}

export default UpdateCategoryView